import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 37228 32408"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:412.553}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528315467248">
        <path
          d="M34916 1592H2312c-141 0-255-114-255-256 0-141 114-255 255-255h32604c141 0 255 114 255 255 0 142-114 256-255 256z"
          className="fill stroke1"
          style={{
            strokeWidth: 412.553,
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M1336 717c-341 0-619 278-619 619s278 619 619 619c342 0 619-278 619-619s-278-619-619-619zm0 1749c-623 0-1130-507-1130-1130S713 206 1336 206s1131 507 1131 1130-508 1130-1131 1130zM35892 717c-342 0-619 278-619 619s277 619 619 619c341 0 618-278 618-619s-277-619-618-619zm0 1749c-624 0-1130-507-1130-1130s506-1130 1130-1130c623 0 1130 507 1130 1130s-507 1130-1130 1130zM3417 31426c-141 0-256-115-256-256v-9769c0-142 115-256 256-256s255 114 255 256v9769c0 141-114 256-255 256zM3417 20035c-141 0-256-114-256-256V1336c0-141 115-255 256-255s255 114 255 255v18443c0 142-114 256-255 256z"
                    className="fill stroke1"
          style={{
            strokeWidth: 412.553,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M3680 20035c-36 0-73-8-108-25-128-59-183-211-124-339 1193-2560 2094-6532 2605-11485 387-3755 415-6779 415-6809 1-142 117-256 258-254 141 1 255 117 254 258-1 30-29 3074-418 6852-360 3495-1113 8354-2650 11654-44 93-136 148-232 148z"
                    className="fill stroke1"
          style={{
            strokeWidth: 412.553,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M3680 20035c-105 0-203-65-240-169-48-132 20-279 153-327 1947-705 3599-4053 4777-9683 902-4308 1202-8454 1205-8495 10-141 132-247 273-237s247 132 237 273c-3 42-305 4217-1213 8558-1234 5899-2952 9285-5104 10065-29 10-59 15-88 15z"
                    className="fill stroke1"
          style={{
            strokeWidth: 412.553,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M4704 19847c-98 0-191-56-234-151-57-129 0-280 129-337 3587-1608 5830-6403 7080-10142 1365-4085 1872-7834 1878-7872 18-140 147-238 287-219 140 18 238 146 219 287-4 37-518 3828-1897 7958-812 2432-1762 4507-2824 6168-1340 2096-2865 3538-4534 4286-33 15-70 22-104 22z"
                    className="fill stroke1"
          style={{
            strokeWidth: 412.553,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M5518 19847c-95 0-185-52-230-143-62-127-10-279 117-342 4320-2119 7512-6910 9430-10557 2085-3965 3152-7465 3163-7500 40-135 183-211 318-171 136 41 212 184 171 319-10 35-1092 3583-3200 7591-1240 2358-2588 4413-4007 6110-1782 2132-3682 3702-5649 4667-37 18-75 26-113 26z"
                    className="fill stroke1"
          style={{
            strokeWidth: 412.553,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M6241 19847c-105 0-203-65-240-169-48-133 22-279 154-327 5655-2024 9901-6821 12467-10490 2790-3988 4254-7543 4269-7579 53-130 202-193 333-140s193 202 140 333c-15 37-1495 3635-4316 7670-1659 2372-3450 4430-5324 6118-2350 2116-4838 3654-7397 4569-28 10-56 15-86 15z"
                    className="fill stroke1"
          style={{
            strokeWidth: 412.553,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M2841 20035c-207 0-374 168-374 374v362c0 206 167 374 374 374h6359c206 0 374-168 374-374v-362c0-206-168-374-374-374H2841zm6359 1622H2841c-489 0-886-398-886-886v-362c0-488 397-886 886-886h6359c488 0 885 398 885 886v362c0 488-397 886-885 886z"
                    className="fill stroke1"
          style={{
            strokeWidth: 412.553,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M7465 32202c-891 0-2259-570-4180-1730-121-73-161-230-87-351 73-121 230-160 350-87 3250 1962 4194 1764 4467 1472 249-266 577-1328-1724-5449-1299-2328-2805-4488-2821-4510-80-115-52-275 64-356 116-80 275-53 356 63 15 22 1534 2200 2846 4550 1839 3294 2380 5273 1653 6051-216 230-521 347-924 347z"
                    className="fill stroke1"
          style={{
            strokeWidth: 412.553,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M9361 30026c-340 0-735-42-1186-128-138-26-230-160-204-298 27-139 160-230 299-204 1184 224 1920 133 2129-264 195-371 173-1427-2164-4328-1372-1704-2882-3207-2897-3222-100-99-101-261-1-362 99-99 261-100 361-1 15 16 1543 1536 2933 3261 1951 2421 2677 4021 2220 4890-230 438-722 656-1490 656z"
                    className="fill stroke1"
          style={{
            strokeWidth: 412.553,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M11766 27496c-447 0-1016-76-1717-229-139-30-226-166-196-304s166-226 304-196c2036 444 2309 91 2343 16 47-104 155-731-2303-2920-1338-1193-2766-2246-2780-2256-114-84-138-244-55-357 84-115 244-139 358-55 14 11 1460 1076 2815 2284 2569 2287 2617 3101 2431 3514-152 336-543 503-1200 503z"
                    className="fill stroke1"
          style={{
            strokeWidth: 412.553,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M32140 30508H8418c-142 0-256-114-256-255 0-142 114-256 256-256h23722c780 0 1415-635 1415-1416V1336c0-141 115-255 256-255s256 114 256 255v27245c0 1063-865 1928-1927 1927z"
                    className="fill stroke1"
          style={{
            strokeWidth: 412.553,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M18740 30508c-142 0-256-114-256-255V9139c0-141 114-256 256-256 141 0 255 115 255 256v21114c0 141-114 256-255 255zM19826 30508c-142 0-256-114-256-255V7523c0-141 114-255 256-255 141 0 255 114 255 255v22730c0 141-114 256-255 255z"
                    className="fill stroke1"
          style={{
            strokeWidth: 412.553,
            strokeLinejoin: "round",
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
